"use client";

import { useState } from "react";
import { SlidersHorizontal, X } from "lucide-react";
import { cn } from "@/lib/utils";
import { ProductFilters, useProductFilters } from "@/components/product/ProductFilters";
import { useTranslations } from "next-intl";

export function WigsMobileFilters() {
  const [open, setOpen] = useState(false);
  const { totalActiveFilterCount } = useProductFilters();
  const t = useTranslations("product");
  const tc = useTranslations("common");

  return (
    <>
      {/* Toggle button — visible only on mobile */}
      <button
        onClick={() => setOpen(true)}
        className="flex items-center gap-1.5 text-xs font-medium uppercase tracking-widest text-brand-dark lg:hidden"
      >
        <SlidersHorizontal className="h-4 w-4" />
        {t("filters")}
        {totalActiveFilterCount > 0 && (
          <span className="flex h-4 min-w-[1rem] items-center justify-center rounded-full bg-brand-gold px-1 text-[10px] font-bold text-white">
            {totalActiveFilterCount}
          </span>
        )}
      </button>

      {/* Backdrop */}
      {open && (
        <div
          className="fixed inset-0 z-40 bg-brand-dark/40 lg:hidden"
          onClick={() => setOpen(false)}
        />
      )}

      {/* Slide-out panel */}
      <div
        className={cn(
          "fixed inset-y-0 start-0 z-50 w-80 max-w-[85vw] transform bg-white p-6 shadow-xl transition-transform duration-300 ease-out lg:hidden",
          open ? "translate-x-0 rtl:-translate-x-0" : "-translate-x-full rtl:translate-x-full"
        )}
      >
        <div className="mb-4 flex items-center justify-between">
          <h2 className="flex items-center gap-2 text-sm font-semibold uppercase tracking-widest text-brand-dark">
            {t("filters")}
            {totalActiveFilterCount > 0 && (
              <span className="flex h-5 min-w-[1.25rem] items-center justify-center rounded-full bg-brand-gold px-1.5 text-[11px] font-bold text-white">
                {totalActiveFilterCount}
              </span>
            )}
          </h2>
          <button
            onClick={() => setOpen(false)}
            className="flex h-8 w-8 items-center justify-center text-brand-muted transition-colors hover:text-brand-dark"
            aria-label={tc("closeFilters")}
          >
            <X className="h-5 w-5" />
          </button>
        </div>
        <div className="h-[calc(100dvh-80px)] overflow-y-auto">
          <ProductFilters />
        </div>
      </div>
    </>
  );
}
